export default __webpack_public_path__ + "static/media/red-darken-historical.b2fb1304.svg";